export const AUSTRALIA_PRODUCTION_SITE_URL = "https://lynicebuy.shop";
export const DEFAULT_TEST_SITE_URL = "http://xjhy.mall-test.buyagent.omszt.com:8081";

export function resolveDevelopmentEnvironment(env = {}) {
  const apiEnvironment = String(env.MALL_API_ENV || "test").trim().toLowerCase();
  if (!["test", "prod"].includes(apiEnvironment)) {
    throw new Error("MALL_API_ENV must be test or prod");
  }
  const siteUrl = new URL(env.NUXT_PUBLIC_DEV_SITE_URL || (
    apiEnvironment === "prod" ? AUSTRALIA_PRODUCTION_SITE_URL : DEFAULT_TEST_SITE_URL
  )).origin;
  return {
    apiEnvironment,
    siteUrl,
    proxyUrl: apiEnvironment === "prod" ? `${siteUrl}/api` : "http://xjhy.m-shop-test.omszt.com:7888/api",
    shopAppUrl: apiEnvironment === "prod" ? `${siteUrl}/api/cmsadmin` : "http://gateway.sztshop-test.omszt.com:7003",
    frontServerUrl: apiEnvironment === "prod" ? `${siteUrl}/api/cmsadmin/frontServer` : "http://mallstore.sztshop-test.omszt.com:7003/api/cmsadmin/frontServer",
  };
}

export function resolveUpstreamUrls(env = {}, proxyLinks = {}) {
  const development = resolveDevelopmentEnvironment(env);
  const frontServerOverride = env.FRONT_SERVER_URL || env.NUXT_PUBLIC_FRONT_SERVER_URL;
  if (env.NODE_ENV === "development") {
    return {
      ...development,
      frontServerUrl: development.apiEnvironment === "prod" || !frontServerOverride
        ? development.frontServerUrl
        : frontServerOverride.replace(/\/+$/, ""),
      qiankunSiteUrl: development.apiEnvironment === "prod"
        ? development.siteUrl.replace(/^https?:/, "")
        : "//xjhy.shopmember-test.omszt.com:7888",
      qiankunAssetOrigin: development.apiEnvironment === "prod"
        ? development.siteUrl
        : "http://xjhy.shopmember-test.omszt.com:7888",
    };
  }
  return {
    proxyUrl: `http://${proxyLinks.collectionSite}`,
    shopAppUrl: proxyLinks.shopSite,
    frontServerUrl: frontServerOverride ? frontServerOverride.replace(/\/+$/, "") : proxyLinks.frontServer,
    qiankunSiteUrl: `//${proxyLinks.qiankunSite}`,
    qiankunAssetOrigin: `http://${proxyLinks.qiankunSite}`,
  };
}
